export const API_VERSION = process.env.REACT_APP_API_VERSION;
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const RECAPTCHA = process.env.REACT_APP_RECAPTCHA;
export const PUBLIC_URL = process.env.PUBLIC_URL;
export const CHECK_NEEDS = process.env.REACT_CHECK_NEEDS === "true";
export const DOCS_URL = process.env.REACT_APP_DOCS_URL;